import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=1916074f"
import script from "./LayoutBase.vue?vue&type=script&lang=js"
export * from "./LayoutBase.vue?vue&type=script&lang=js"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=1916074f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports